export const JOURNEY_STEPS = [
  {
    key: 'onboarding',
    path: '/onboarding',
    next: '/discovery',
    sidebar: null,
  },
  {
    key: 'discovery',
    path: '/discovery',
    next: '/select-seven',
    sidebar: null,
  },
  {
    key: 'select-seven',
    path: '/select-seven',
    next: '/soft-transition',
    sidebar: null,
  },
  {
    key: 'soft-transition',
    path: '/soft-transition',
    next: '/head-to-head',
    sidebar: null,
  },
  {
    key: 'dashboard',
    path: '/dashboard',
    next: '/round',
    sidebar: null,
  },
  {
    key: 'round',
    path: '/round',
    next: '/head-to-head',
    sidebar: {
      label: 'Round 3 / 6',
      name: 'Chemistry Round',
      sub: 'A 20-second prompt. No retakes.',
      to: '/round',
      cta: 'Advance',
    },
  },
  {
    key: 'head-to-head',
    path: '/head-to-head',
    next: '/bracket',
    sidebar: {
      label: 'Round 4 / 6',
      name: 'Head to Head',
      sub: 'Two responses. One advances.',
      to: '/head-to-head',
      cta: 'Advance',
    },
  },
  {
    key: 'bracket',
    path: '/bracket',
    next: '/finalists',
    sidebar: {
      label: 'Round 5 / 6',
      name: 'Bracket',
      sub: 'The funnel of intention.',
      to: '/bracket',
      cta: 'Advance',
    },
  },
  {
    key: 'finalists',
    path: '/finalists',
    next: '/reveal',
    sidebar: {
      label: 'Round 6 / 6',
      name: 'Final Choice',
      sub: 'Two remain. Take your time.',
      to: '/finalists',
      cta: 'Advance',
    },
  },
  {
    key: 'reveal',
    path: '/reveal',
    next: '/chat',
    sidebar: {
      label: 'Winner Reveal',
      name: 'Winner Reveal',
      sub: 'Your Bora Moyo has been selected.',
      to: '/reveal',
      cta: 'Advance',
    },
  },
  {
    key: 'chat',
    path: '/chat',
    next: null,
    sidebar: null,
  },
];

export function getJourneyStep(pathname) {
  return JOURNEY_STEPS.find((s) => s.path === pathname) ?? null;
}

export function getNextJourneyPath(pathname) {
  return getJourneyStep(pathname)?.next ?? null;
}
